var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-list',{attrs:{"role":_vm.USER_ROLES.CLIENT_AGENT}})
}
var staticRenderFns = []

export { render, staticRenderFns }